@if (isAuthenticated$ | async) {
    <a [ngClass]="depositButtonClass" (click)="makeDeposit()">{{ sitecore.betslip.messages.Deposit }}</a>

    <div class="digital-header__balance">
        <div class="digital-header__balance-title">{{ sitecore.betslip.linear.AccountBalance }}</div>
        <bs-wallet-type-container
            trackingPosition="Betslip"
            [bottomOptions]="true"
            [inColumn]="false"
            [showExtendedInfo]="false"
            [singleWallet]="true" />
    </div>
} @else {
    <div class="digital-header__button">
        @if (showLoginButtonInHeader) {
            <a [ngClass]="loginButtonClass" (click)="login()">{{ sitecore.betslip.linear.Login }}</a>
        }
        <a [ngClass]="registerButtonClass" (click)="register()">{{ sitecore.betslip.linear.Register }}</a>
    </div>
    @if (!isEpcot) {
        <div class="header-title">{{ sitecore.betslip.messages.Title }}</div>
    }
}

@if (showXCloseButton) {
    <div class="remove-button theme-ex digital-header__x-close-button" (click)="close()"></div>
} @else {
    <a [ngClass]="closeButtonClass" (click)="close()">{{ sitecore.betslip.messages.CloseBetslip }}</a>
}
